// native
import { NgModule } from "@angular/core";

// module
import { SharedModule } from '../shared/shared.module';

// component
import { NavigationButtonComponent } from './components/navigation/navigation-button.component';
import { NavigationButtonAddonComponent } from './components/navigation/navigation-button-addon.component';
import { NavigationCollectionComponent } from './components/navigation/navigation-collection.component';
import { NavigationCollectionSharedComponent } from './components/navigation/navigation-collection-shared.component';
import { NavigationListComponent } from './components/navigation/navigation-list.component';
import { NavigationSmartListComponent } from './components/navigation/navigation-smartlist.component';
import { NavigationTagsComponent } from './components/navigation/navigation-tags.component';
import { NavigationTagComponent } from './components/navigation/navigation-tag.component';
import { ReferencesComponent } from './components/references.component';
import { ItemsComponent } from './components/items/items.component';
import { ItemPanelComponent } from './components/item-panel/item-panel.component';
import { CitationsQueueComponent } from './components/citations-queue/citations-queue.component';
import { ActiveReferencesComponent } from './components/active-references/active-references.component';
import { CitationDrawerComponent } from './components/citation-drawer/citation-drawer.component';
import { OverridePanelComponent } from './components/override-panel/override-panel.component';
import { OptionsPanelComponent } from './components/options-panel/options-panel.component';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    NavigationButtonComponent,
    NavigationButtonAddonComponent,
    NavigationCollectionComponent,
    NavigationCollectionSharedComponent,
    NavigationListComponent,
    NavigationSmartListComponent,
    NavigationTagsComponent,
    NavigationTagComponent,
    ReferencesComponent,
    ItemsComponent,
    ItemPanelComponent,
    CitationsQueueComponent,
    ActiveReferencesComponent,
    CitationDrawerComponent,
    OverridePanelComponent,
    OptionsPanelComponent
  ],
  exports: [ 
    ReferencesComponent,
    ItemPanelComponent,
    OverridePanelComponent,
    OptionsPanelComponent,
    ItemsComponent
   ]
})
export class ReferencesModule { }